module.exports = __webpack_public_path__ + "static/media/img_g5.40da4228.webp";